import { get as getRequest, post as postRequest } from 'axios'
import Cookies from 'js-cookie'
import { tryCatch, pipe } from 'rambda'

const log = console.info
let userData = undefined
let getQueue = []
let SITE_DATA;

// @FIXME: This should be a user facing error function, so for now we will
// just throw an error for raven to catch but we should have a generic way
// to throw user facing errors
const errorFunction = function(error){
  throw new Error('User Error', error)
}

export default {
	init,
	get,
	login,
}

// Initialise the `User` module
export function init(siteData) {
	// Make a reference to siteData
	SITE_DATA = siteData
	requestUserData()
	userDisplayName()
}

// Takes a `Fn` and when the user data is ready, returns `UserData`
export function get(callback) {
	if (userData) {
		callback(userData)
	} else {
		getQueue.push(callback)
	}
}

// login :: (String, String) -> Promise<undefiend | UserData>
// Performs a login
export async function login(username, password) {
	if (!username || !password) {
		return errorFunction('Please fill out all required fields.')
	}
	try {
		const {data} = await postRequest(SITE_DATA.loginURL, {username, password})
		if(!data.authenticated){ return errorFunction(data.error) }
		userData = data
		clearGetQueue()
		return data
		// @NOTE: $(rnn).trigger(loginEvent) - Is this needed anymore? Don't think so
	} catch (e) {
		return errorFunction('There was an error attempting to login, please try again later')
	}
}

function clearGetQueue() {
	var callback

	while (getQueue.length > 0) {
		callback = getQueue.pop()
		callback(userData)
		callback = null
	}
}

// Safely parse the user data, if we throw an error return `{}`
const parseUserData = tryCatch(pipe(atob, decodeURIComponent, JSON.parse), {})

// Returns the current `UserData` from a cookie, or an empty object
export const cookieUserData = () => parseUserData(Cookies.get('apn_user_data'))

async function requestUserData() {
	log('[user]', 'Requesting user data from server...')
	// Only want to trigger the userstatus request if the current site has a my-account URL set up
	// - currently configured by setting rnn.site.userAccountURL
	if (SITE_DATA.userAccountURL) {
		const response = await getRequest(SITE_DATA.userDataURL)
		userData = response.data // data?
		clearGetQueue()
	}
}

// Set the inner contents of all elements with the class `.user_display_name` to
// the user's account name
const userDisplayName = () => get(user =>
	[...document.querySelectorAll('.user_display_name')]
		.map($e => $e.innerHTML = user.display_name))

//           isSubscriber :: () => Boolean
export const isSubscriber = () =>
	Cookies.get('subscribed') === 'true' || cookieUserData().subscribed

export function generateSubscribedString(){
  const user = cookieUserData()
  if(!user){ return 'anonymous' }
  return user.isStaff === true
    ? 'staff'
    : user.subscribed === true
      ? 'subscribed'
      : 'account'
}
